/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ShivaWebSecuredConfiguration } from '../shiva-web-secured-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { addFavouriteStation } from '../fn/personal-space/add-favourite-station';
import { AddFavouriteStation$Params } from '../fn/personal-space/add-favourite-station';
import { changePasswordUser } from '../fn/personal-space/change-password-user';
import { ChangePasswordUser$Params } from '../fn/personal-space/change-password-user';
import { deleteFavouriteStation } from '../fn/personal-space/delete-favourite-station';
import { DeleteFavouriteStation$Params } from '../fn/personal-space/delete-favourite-station';
import { FeatureCollection } from '../models/feature-collection';
import { GeneratedNotePagedList } from '../models/generated-note-paged-list';
import { getUserProfile } from '../fn/personal-space/get-user-profile';
import { GetUserProfile$Params } from '../fn/personal-space/get-user-profile';
import { permanentlyDeleteCurrentUser } from '../fn/personal-space/permanently-delete-current-user';
import { PermanentlyDeleteCurrentUser$Params } from '../fn/personal-space/permanently-delete-current-user';
import { personalMapStations } from '../fn/personal-space/personal-map-stations';
import { PersonalMapStations$Params } from '../fn/personal-space/personal-map-stations';
import { personalSearchGeneratedNotes$Any } from '../fn/personal-space/personal-search-generated-notes-any';
import { PersonalSearchGeneratedNotes$Any$Params } from '../fn/personal-space/personal-search-generated-notes-any';
import { personalSearchGeneratedNotes$Json } from '../fn/personal-space/personal-search-generated-notes-json';
import { PersonalSearchGeneratedNotes$Json$Params } from '../fn/personal-space/personal-search-generated-notes-json';
import { personalSearchStation$Any } from '../fn/personal-space/personal-search-station-any';
import { PersonalSearchStation$Any$Params } from '../fn/personal-space/personal-search-station-any';
import { personalSearchStation$Json } from '../fn/personal-space/personal-search-station-json';
import { PersonalSearchStation$Json$Params } from '../fn/personal-space/personal-search-station-json';
import { personalSearchSubscriptions$Any } from '../fn/personal-space/personal-search-subscriptions-any';
import { PersonalSearchSubscriptions$Any$Params } from '../fn/personal-space/personal-search-subscriptions-any';
import { personalSearchSubscriptions$Json } from '../fn/personal-space/personal-search-subscriptions-json';
import { PersonalSearchSubscriptions$Json$Params } from '../fn/personal-space/personal-search-subscriptions-json';
import { StationPagedList } from '../models/station-paged-list';
import { SubscriptionPagedList } from '../models/subscription-paged-list';
import { updateProfileUser } from '../fn/personal-space/update-profile-user';
import { UpdateProfileUser$Params } from '../fn/personal-space/update-profile-user';
import { UserProfile } from '../models/user-profile';


/**
 * All about the user personal space
 */
@Injectable({ providedIn: 'root' })
export class PersonalSpaceService extends BaseService {
  constructor(config: ShivaWebSecuredConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getUserProfile()` */
  static readonly GetUserProfilePath = '/personalspace';

  /**
   * Retrieve a user's profile.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getUserProfile()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUserProfile$Response(params?: GetUserProfile$Params, context?: HttpContext): Observable<StrictHttpResponse<UserProfile>> {
    return getUserProfile(this.http, this.rootUrl, params, context);
  }

  /**
   * Retrieve a user's profile.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getUserProfile$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUserProfile(params?: GetUserProfile$Params, context?: HttpContext): Observable<UserProfile> {
    return this.getUserProfile$Response(params, context).pipe(
      map((r: StrictHttpResponse<UserProfile>): UserProfile => r.body)
    );
  }

  /** Path part for operation `permanentlyDeleteCurrentUser()` */
  static readonly PermanentlyDeleteCurrentUserPath = '/personalspace';

  /**
   * Permanently delete a user.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `permanentlyDeleteCurrentUser()` instead.
   *
   * This method doesn't expect any request body.
   */
  permanentlyDeleteCurrentUser$Response(params?: PermanentlyDeleteCurrentUser$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return permanentlyDeleteCurrentUser(this.http, this.rootUrl, params, context);
  }

  /**
   * Permanently delete a user.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `permanentlyDeleteCurrentUser$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  permanentlyDeleteCurrentUser(params?: PermanentlyDeleteCurrentUser$Params, context?: HttpContext): Observable<void> {
    return this.permanentlyDeleteCurrentUser$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `changePasswordUser()` */
  static readonly ChangePasswordUserPath = '/personalspace/change-password';

  /**
   * Change a logged user password.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `changePasswordUser()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  changePasswordUser$Response(params: ChangePasswordUser$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return changePasswordUser(this.http, this.rootUrl, params, context);
  }

  /**
   * Change a logged user password.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `changePasswordUser$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  changePasswordUser(params: ChangePasswordUser$Params, context?: HttpContext): Observable<void> {
    return this.changePasswordUser$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `updateProfileUser()` */
  static readonly UpdateProfileUserPath = '/personalspace/profile-update';

  /**
   * Update a user's profile.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateProfileUser()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateProfileUser$Response(params: UpdateProfileUser$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return updateProfileUser(this.http, this.rootUrl, params, context);
  }

  /**
   * Update a user's profile.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateProfileUser$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateProfileUser(params: UpdateProfileUser$Params, context?: HttpContext): Observable<void> {
    return this.updateProfileUser$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `personalSearchGeneratedNotes()` */
  static readonly PersonalSearchGeneratedNotesPath = '/personalspace/notes-generated/search';

  /**
   * Get the personal generated notes, with pagination.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `personalSearchGeneratedNotes$Json()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  personalSearchGeneratedNotes$Json$Response(params?: PersonalSearchGeneratedNotes$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<GeneratedNotePagedList>> {
    return personalSearchGeneratedNotes$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Get the personal generated notes, with pagination.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `personalSearchGeneratedNotes$Json$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  personalSearchGeneratedNotes$Json(params?: PersonalSearchGeneratedNotes$Json$Params, context?: HttpContext): Observable<GeneratedNotePagedList> {
    return this.personalSearchGeneratedNotes$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<GeneratedNotePagedList>): GeneratedNotePagedList => r.body)
    );
  }

  /**
   * Get the personal generated notes, with pagination.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `personalSearchGeneratedNotes$Any()` instead.
   *
   * This method sends `application/octet-stream` and handles request body of type `application/octet-stream`.
   */
  personalSearchGeneratedNotes$Any$Response(params?: PersonalSearchGeneratedNotes$Any$Params, context?: HttpContext): Observable<StrictHttpResponse<GeneratedNotePagedList>> {
    return personalSearchGeneratedNotes$Any(this.http, this.rootUrl, params, context);
  }

  /**
   * Get the personal generated notes, with pagination.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `personalSearchGeneratedNotes$Any$Response()` instead.
   *
   * This method sends `application/octet-stream` and handles request body of type `application/octet-stream`.
   */
  personalSearchGeneratedNotes$Any(params?: PersonalSearchGeneratedNotes$Any$Params, context?: HttpContext): Observable<GeneratedNotePagedList> {
    return this.personalSearchGeneratedNotes$Any$Response(params, context).pipe(
      map((r: StrictHttpResponse<GeneratedNotePagedList>): GeneratedNotePagedList => r.body)
    );
  }

  /** Path part for operation `personalSearchStation()` */
  static readonly PersonalSearchStationPath = '/personalspace/station/search';

  /**
   * Search my stations, with pagination.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `personalSearchStation$Json()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  personalSearchStation$Json$Response(params?: PersonalSearchStation$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<StationPagedList>> {
    return personalSearchStation$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Search my stations, with pagination.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `personalSearchStation$Json$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  personalSearchStation$Json(params?: PersonalSearchStation$Json$Params, context?: HttpContext): Observable<StationPagedList> {
    return this.personalSearchStation$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<StationPagedList>): StationPagedList => r.body)
    );
  }

  /**
   * Search my stations, with pagination.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `personalSearchStation$Any()` instead.
   *
   * This method sends `application/octet-stream` and handles request body of type `application/octet-stream`.
   */
  personalSearchStation$Any$Response(params?: PersonalSearchStation$Any$Params, context?: HttpContext): Observable<StrictHttpResponse<StationPagedList>> {
    return personalSearchStation$Any(this.http, this.rootUrl, params, context);
  }

  /**
   * Search my stations, with pagination.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `personalSearchStation$Any$Response()` instead.
   *
   * This method sends `application/octet-stream` and handles request body of type `application/octet-stream`.
   */
  personalSearchStation$Any(params?: PersonalSearchStation$Any$Params, context?: HttpContext): Observable<StationPagedList> {
    return this.personalSearchStation$Any$Response(params, context).pipe(
      map((r: StrictHttpResponse<StationPagedList>): StationPagedList => r.body)
    );
  }

  /** Path part for operation `addFavouriteStation()` */
  static readonly AddFavouriteStationPath = '/personalspace/station/{uid}/favorites';

  /**
   * Add a station to my favourites.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `addFavouriteStation()` instead.
   *
   * This method doesn't expect any request body.
   */
  addFavouriteStation$Response(params: AddFavouriteStation$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return addFavouriteStation(this.http, this.rootUrl, params, context);
  }

  /**
   * Add a station to my favourites.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `addFavouriteStation$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  addFavouriteStation(params: AddFavouriteStation$Params, context?: HttpContext): Observable<void> {
    return this.addFavouriteStation$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `deleteFavouriteStation()` */
  static readonly DeleteFavouriteStationPath = '/personalspace/station/{uid}/favorites';

  /**
   * Delete a station from my favourites.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteFavouriteStation()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteFavouriteStation$Response(params: DeleteFavouriteStation$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return deleteFavouriteStation(this.http, this.rootUrl, params, context);
  }

  /**
   * Delete a station from my favourites.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteFavouriteStation$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteFavouriteStation(params: DeleteFavouriteStation$Params, context?: HttpContext): Observable<void> {
    return this.deleteFavouriteStation$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `personalSearchSubscriptions()` */
  static readonly PersonalSearchSubscriptionsPath = '/personalspace/search';

  /**
   * Search my subscriptions, with pagination.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `personalSearchSubscriptions$Json()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  personalSearchSubscriptions$Json$Response(params?: PersonalSearchSubscriptions$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<SubscriptionPagedList>> {
    return personalSearchSubscriptions$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Search my subscriptions, with pagination.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `personalSearchSubscriptions$Json$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  personalSearchSubscriptions$Json(params?: PersonalSearchSubscriptions$Json$Params, context?: HttpContext): Observable<SubscriptionPagedList> {
    return this.personalSearchSubscriptions$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<SubscriptionPagedList>): SubscriptionPagedList => r.body)
    );
  }

  /**
   * Search my subscriptions, with pagination.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `personalSearchSubscriptions$Any()` instead.
   *
   * This method sends `application/octet-stream` and handles request body of type `application/octet-stream`.
   */
  personalSearchSubscriptions$Any$Response(params?: PersonalSearchSubscriptions$Any$Params, context?: HttpContext): Observable<StrictHttpResponse<SubscriptionPagedList>> {
    return personalSearchSubscriptions$Any(this.http, this.rootUrl, params, context);
  }

  /**
   * Search my subscriptions, with pagination.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `personalSearchSubscriptions$Any$Response()` instead.
   *
   * This method sends `application/octet-stream` and handles request body of type `application/octet-stream`.
   */
  personalSearchSubscriptions$Any(params?: PersonalSearchSubscriptions$Any$Params, context?: HttpContext): Observable<SubscriptionPagedList> {
    return this.personalSearchSubscriptions$Any$Response(params, context).pipe(
      map((r: StrictHttpResponse<SubscriptionPagedList>): SubscriptionPagedList => r.body)
    );
  }

  /** Path part for operation `personalMapStations()` */
  static readonly PersonalMapStationsPath = '/personalspace/map';

  /**
   * Retrieve personal stations geolocalized on map.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `personalMapStations()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  personalMapStations$Response(params: PersonalMapStations$Params, context?: HttpContext): Observable<StrictHttpResponse<FeatureCollection>> {
    return personalMapStations(this.http, this.rootUrl, params, context);
  }

  /**
   * Retrieve personal stations geolocalized on map.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `personalMapStations$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  personalMapStations(params: PersonalMapStations$Params, context?: HttpContext): Observable<FeatureCollection> {
    return this.personalMapStations$Response(params, context).pipe(
      map((r: StrictHttpResponse<FeatureCollection>): FeatureCollection => r.body)
    );
  }

}
